(function () {
  'use strict';

  if (window.wfsUnderlayUpsellInitialized) return;
  window.wfsUnderlayUpsellInitialized = true;

  var overlay = document.getElementById('wfs-underlay-upsell');
  var configElement = document.getElementById('wfs-underlay-upsell-config');
  if (!overlay || !configElement) return;

  var config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    return;
  }

  var products = (config.products || []).filter(function (product) {
    return product && product.variantId;
  });
  if (!products.length) return;

  var list = overlay.querySelector('.wfs-underlay-upsell__list');
  var closeButton = overlay.querySelector('.wfs-underlay-upsell__close');
  var dismissButton = overlay.querySelector('.wfs-underlay-upsell__dismiss');
  var isOpen = false;

  function money(cents) {
    return new Intl.NumberFormat('en-IE', {
      style: 'currency',
      currency: 'EUR'
    }).format(cents / 100);
  }

  function escapeHtml(value) {
    var element = document.createElement('span');
    element.textContent = value || '';
    return element.innerHTML;
  }

  function coverageFromTitle(title) {
    var match = (title || '').toLowerCase().match(/(\d+(?:\.\d+)?)\s*(?:m(?:²|2|\s*sq)|sq\s*m|sqm)/);
    return match ? parseFloat(match[1]) : 0;
  }

  function recommendedQuantity(flooringQuantity, title) {
    var lowerTitle = (title || '').toLowerCase();
    if (lowerTitle.indexOf('recoll') !== -1 || lowerTitle.indexOf('adhesive') !== -1) return 1;
    var coverage = coverageFromTitle(title);
    return coverage > 0 ? Math.max(1, Math.ceil(flooringQuantity / coverage)) : 1;
  }

  products.forEach(function (product, index) {
    var card = document.createElement('article');
    card.className = 'wfs-underlay-card';
    card.setAttribute('data-product-index', index);
    card.innerHTML =
      '<a class="wfs-underlay-card__image" href="' + product.url + '">' +
        '<img src="' + product.image + '" alt="' + escapeHtml(product.title) + '" width="110" height="110" loading="lazy">' +
      '</a>' +
      '<div class="wfs-underlay-card__details">' +
        '<a class="wfs-underlay-card__title" href="' + product.url + '">' + escapeHtml(product.title) + '</a>' +
        '<div class="wfs-underlay-card__price" data-unit-price="' + product.price + '">' + money(product.price) + '</div>' +
        '<div class="wfs-underlay-card__coverage" data-coverage="' + coverageFromTitle(product.title) + '"></div>' +
        '<div class="wfs-underlay-card__coverage" data-coverage="' + coverageFromTitle(product.title) + '"></div>' +
        '<div class="wfs-underlay-card__coverage" data-coverage="' + coverageFromTitle(product.title) + '"></div>' +
        '<div class="wfs-underlay-card__coverage" data-coverage="' + coverageFromTitle(product.title) + '"></div>' +
        '<div class="wfs-underlay-card__coverage" data-coverage="' + coverageFromTitle(product.title) + '"></div>' +
        '<div class="wfs-underlay-card__coverage" data-coverage="' + coverageFromTitle(product.title) + '"></div>' +
        '<div class="wfs-underlay-card__actions">' +
          '<div class="wfs-underlay-card__quantity">' +
            '<button type="button" data-action="minus" aria-label="Decrease underlay quantity">&minus;</button>' +
            '<input type="number" value="1" min="1" max="99" aria-label="Underlay quantity">' +
            '<button type="button" data-action="plus" aria-label="Increase underlay quantity">&plus;</button>' +
          '</div>' +
          '<button type="button" class="wfs-underlay-card__add" data-variant-id="' + product.variantId + '">ADD TO CART</button>' +
        '</div>' +
      '</div>';
    list.appendChild(card);
  });

  function updateCardPrice(card) {
    var input = card.querySelector('input');
    var price = card.querySelector('.wfs-underlay-card__price');
    var coverageLabel = card.querySelector('.wfs-underlay-card__coverage');
    var quantity = Math.max(1, parseInt(input.value, 10) || 1);
    var coverage = parseFloat(coverageLabel.getAttribute('data-coverage')) || 0;
    input.value = quantity;
    price.textContent = money((parseInt(price.getAttribute('data-unit-price'), 10) || 0) * quantity);
    coverageLabel.textContent = coverage > 0
      ? quantity + (quantity === 1 ? ' roll' : ' rolls') + ' · covers ' + (quantity * coverage) + ' m²'
      : '';
  }

  list.addEventListener('click', function (event) {
    var quantityButton = event.target.closest('[data-action]');
    if (quantityButton) {
      var quantityCard = quantityButton.closest('.wfs-underlay-card');
      var quantityInput = quantityCard.querySelector('input');
      var quantity = Math.max(1, parseInt(quantityInput.value, 10) || 1);
      if (quantityButton.getAttribute('data-action') === 'plus') quantity += 1;
      if (quantityButton.getAttribute('data-action') === 'minus') quantity = Math.max(1, quantity - 1);
      quantityInput.value = quantity;
      updateCardPrice(quantityCard);
      return;
    }

    var addButton = event.target.closest('.wfs-underlay-card__add');
    if (!addButton || addButton.disabled) return;
    var card = addButton.closest('.wfs-underlay-card');
    var underlayQuantity = Math.max(1, parseInt(card.querySelector('input').value, 10) || 1);
    addButton.disabled = true;
    addButton.textContent = 'ADDING…';

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(addButton.getAttribute('data-variant-id'), 10), quantity: underlayQuantity }] })
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to add underlay');
      addButton.textContent = 'ADDED ✓';
      window.setTimeout(function () { window.location.href = '/cart'; }, 500);
    }).catch(function () {
      addButton.disabled = false;
      addButton.textContent = 'ADD TO CART';
    });
  });

  list.addEventListener('change', function (event) {
    if (event.target.matches('input')) updateCardPrice(event.target.closest('.wfs-underlay-card'));
  });

  function show(flooringQuantity) {
    if (isOpen) return;
    isOpen = true;
    overlay.querySelectorAll('.wfs-underlay-card').forEach(function (card, index) {
      var input = card.querySelector('input');
      input.value = recommendedQuantity(flooringQuantity, products[index].title);
      updateCardPrice(card);
    });
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('wfs-underlay-upsell-open');
    closeButton.focus();
  }

  function continueToCart() {
    if (!isOpen) return;
    isOpen = false;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('wfs-underlay-upsell-open');
    window.location.href = '/cart';
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('.product-calculator-form form[action*="/cart/add"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();

    var submitButton = form.querySelector('[type="submit"]');
    if (submitButton) submitButton.disabled = true;
    var formData = new FormData(form);
    var calculator = form.closest('.product-calculator-form');
    var areaInput = calculator && calculator.querySelector('[data-ref-squared-input]');
    var requestedArea = Math.max(1, parseFloat(areaInput && areaInput.value) || 1);

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      body: formData
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to add flooring');
      if (submitButton) submitButton.disabled = false;
      show(requestedArea);
    }).catch(function () {
      if (submitButton) submitButton.disabled = false;
      form.submit();
    });
  }, true);

  closeButton.addEventListener('click', continueToCart);
  dismissButton.addEventListener('click', continueToCart);
  overlay.addEventListener('click', function (event) {
    if (event.target === overlay) continueToCart();
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isOpen) continueToCart();
  });
})();
